module.exports = __webpack_public_path__ + "static/background-voices-44ff0fe36a43d3a88a778b43dba951e3.png";